import { defineComponent as _defineComponent } from 'vue';
import { Primitive } from "reka-ui";
import { cn } from '../../primitives/utils';
import { sidebarMenuButtonVariants } from ".";
export default /*@__PURE__*/ _defineComponent({
    __name: 'SidebarMenuButtonChild',
    props: {
        variant: { type: null, required: false, default: "default" },
        size: { type: null, required: false, default: "default" },
        isActive: { type: Boolean, required: false },
        class: { type: [Boolean, null, String, Object, Array], required: false, skipCheck: true },
        asChild: { type: Boolean, required: false },
        as: { type: null, required: false, default: "button" }
    },
    setup(__props, { expose: __expose }) {
        __expose();
        const props = __props;
        const __returned__ = { props, get Primitive() { return Primitive; }, get cn() { return cn; }, get sidebarMenuButtonVariants() { return sidebarMenuButtonVariants; } };
        Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true });
        return __returned__;
    }
});
